export class AddressAutocompletionRequestModel {
  apiKey: string;
  text: string;
  type:
    | "country"
    | "state"
    | "city"
    | "postcode"
    | "street"
    | "amenity"
    | "locality";
  lang: string;
  format: "json" | "xml" | "geojson";
  filter: string;
}
